import { useEffect } from 'react';
import { BreadcrumbLink } from '../components/breadcrumb/Breadcrumb';
import { hideBreadcrumb, showBreadcrumb, updateLinks } from '../store/features/breadcrumb/breadcrumbSlice';
import { useAppDispatch } from '../store/hooks';

export const useUpdateBreadcrumb = (links: BreadcrumbLink[] = [], hide = false) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (hide) {
      dispatch(hideBreadcrumb());
    } else {
      dispatch(showBreadcrumb());
    }
    dispatch(updateLinks(links));
  }, [dispatch, links, hide]);
};
